import { CircularProgress, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from "@mui/material";

import { TableContainer } from "@mui/material";

import { Paper } from "@mui/material";

import { Box } from "@mui/material";

interface DataSourceTableProps {
  sourceColumns: any[];
  sourceData: any[][];
  loading: boolean;
  totalCount: number;
  page: number;
  rowsPerPage: number;
  skipLines: number;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DataSourceTable = ({
  sourceColumns,
  sourceData,
  loading,
  totalCount,
  page,
  rowsPerPage,
  skipLines,
  handleChangePage,
  handleChangeRowsPerPage,
}: DataSourceTableProps) => {
  return (
    <>
      <Typography
        variant="h5"
        sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}
      >
        Source Data
      </Typography>

      <Box
        sx={{
          "& table": {
            tableLayout: "auto",
          },
          "& .MuiTableHead-root .MuiTableCell-root": {
            fontSize: "0.75rem",
            fontWeight: "bold",
            width: "auto",
            whiteSpace: "nowrap",
          },
          "& .MuiTableBody-root .MuiTableCell-root": {
            fontSize: "0.75rem",
            whiteSpace: "nowrap",
          },
        }}
      >
        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {sourceColumns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={sourceColumns.length} align="center">
                    <CircularProgress size={20} />
                  </TableCell>
                </TableRow>
              ) : sourceData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={sourceColumns.length} align="center">
                    <Typography variant="body2">No data available</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                sourceData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => {
                    const isSkipped = rowIndex < skipLines;
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          backgroundColor: isSkipped
                            ? "rgba(255, 255, 0, 0.2)"
                            : undefined,
                          "&:hover": {
                            backgroundColor: isSkipped
                              ? "rgba(255, 255, 0, 0.3)"
                              : undefined,
                          },
                        }}
                      >
                        {row.map((cell, cellIndex) => (
                          <TableCell key={`${rowIndex}-${cellIndex}`}>
                            {cell}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Box>
    </>
  );
};

export default DataSourceTable;
